import React from "react";
import cx from "clsx";
import { isMobile } from "react-device-detect";

import { getTourOffset } from "@/helpers";
import { PLAYBACK_CONST } from "@/constants";
import TourVideoLarge from "@/assets/ELCO_Scroll_Beta_Desktop.mp4";
import TourVideo from "@/assets/ELCO_Scroll_Beta_Mobile_SM_02.mp4";

import styles from "./videoTour.module.scss";

// const getTimeFromKeyframe = keyframe => keyframe / 30;

class VideoTour extends React.PureComponent {
  state = {
    stopIndex: -1,
    videoLoaded: false,
    hasMounted: false,
  };

  tourVideo = React.createRef();
  reqAnimFrame = null;

  componentDidMount() {
    this.tourVideo.current.play();
    this.tourVideo.current.pause();

    if (!isMobile && URL && URL.createObjectURL) {
      const req = new XMLHttpRequest();
      req.open("GET", TourVideoLarge, true);
      req.responseType = "blob";

      req.onload = () => {
        // Onload is triggered even on 404
        // so we need to check the status code
        if (req.status === 200) {
          const videoBlob = req.response;
          const vid = URL.createObjectURL(videoBlob); // IE10+
          // Video is now downloaded
          // and we can set it as source on the video element
          this.tourVideo.current.src = vid;
          this.handleVideoLoaded();
        }
      };
      req.onerror = (err) => {
        // Error
        console.log("error", err);
        debugger;
      };

      req.send();
    } else {
      // Old browser
      this.handleVideoLoaded();
    }

    this.tourVideo.current.addEventListener(
      "loadedmetadata",
      this.handleMetaLoaded
    );

    if (typeof window !== "undefined") {
      this.reqAnimFrame = window.requestAnimationFrame(this.scrollPlay);
    }

    this.setState({ hasMounted: true });
  }

  scrollPlay = () => {
    const { isDesktop } = this.props;
    const offset = getTourOffset(isDesktop);

    const currentFrame =
      Math.max(window.pageYOffset - offset, 0) / PLAYBACK_CONST;

    if (this.tourVideo.current) {
      // this updates the video current frame based on scroll position
      this.tourVideo.current.currentTime = currentFrame;
      this.reqAnimFrame = window.requestAnimationFrame(this.scrollPlay);
    }
  };

  handleMetaLoaded = (event) => {
    const pageHeight = `${Math.floor(event.currentTarget.duration) *
      PLAYBACK_CONST}px`;

    // This should be the value of SCROLL_HEIGHT
    console.log("video duration", `${event.currentTarget.duration}s`);
    console.log("pageHeight", pageHeight);
  };

  handleVideoLoaded = () => {
    // Small wait for video to render
    setTimeout(() => {
      this.setState({ videoLoaded: true });
      this.props.onLoadVideo(true);
    }, 100);
  };

  render() {
    const { isDesktop, videoHeight, hideVideo } = this.props;
    const { videoLoaded } = this.state;

    return (
      <div
        className={cx(styles.scrollWrapper, isDesktop && styles.desktop)}
        style={{
          opacity: videoLoaded ? 1 : 0,
          height: videoHeight,
        }}
      >
        <div className={cx(styles.videoContainer, hideVideo && styles.hidden)}>
          {/* eslint-disable */}
          <video
            playsInline
            preload="auto"
            ref={this.tourVideo}
            className={styles.video}
            src={TourVideo}
          />
          {/* eslint-enable */}
        </div>
      </div>
    );
  }
}

export default VideoTour;
